module.exports = __webpack_public_path__ + "static/media/turkey-partners.50d80450.svg";